<template>
    <div>
        <canvas class="drawing-canvas" ref="drawingcanvas"
            @pointerdown="beginDrawing"
            @pointermove="keepDrawing"
            @pointerup="stopDrawing"
            @pointerleave="stopDrawing"
            @pointercancel="stopDrawing"
        />
        <div class="tools">
            <base-button type="secondary"
                class="btn-icon-only rounded-circle mr-0"
                @click="reset(true)"
            >
                <span class="btn-inner--icon"><i class="far fa-trash-alt"></i></span>
            </base-button>
        </div>
    </div>
</template>

<script>
    export default {

        model: {
            prop: 'value',
            event: 'change'
        },

        props: {
            value: [File],

            url: {
                type: String,
                default: 'http://'
            },

            formData: {
                type: Object,
                default: () => {}
            },
        },

        data() {
            return {
                x: 0,
                y: 0,
                isDrawing: false,
                ctx: null,

                drawedImage: null,    // URL de l'image capturée
                file: null,
            }
        },

        methods: {

            adjustCanvasSize() {
                const canvas = this.$refs.drawingcanvas;
                const rect = canvas.getBoundingClientRect();
                canvas.width = rect.width;
                canvas.height = rect.height;
            },

            getCanvasCoordinates(event) {
                const rect = event.target.getBoundingClientRect();
                const scaleX = event.target.width / rect.width;
                const scaleY = event.target.height / rect.height;
                return {
                    x: (event.clientX - rect.left) * scaleX,
                    y: (event.clientY - rect.top) * scaleY
                };
            },

            drawLine(x1, y1, x2, y2) {
                this.ctx.beginPath();
                this.ctx.strokeStyle = 'black';
                this.ctx.lineWidth = 2;
                this.ctx.moveTo(x1, y1);
                this.ctx.lineTo(x2, y2);
                this.ctx.stroke();
                this.ctx.closePath();
            },

            beginDrawing(event) {
                if (!this.ctx) {
                    this.adjustCanvasSize()
                    this.ctx = this.$refs.drawingcanvas.getContext('2d')
                }
                const { x, y } = this.getCanvasCoordinates(event)
                this.x = x
                this.y = y
                this.isDrawing = true
            },

            keepDrawing(event) {
                if (this.isDrawing) {
                    const { x, y } = this.getCanvasCoordinates(event);
                    this.drawLine(this.x, this.y, x, y);
                    this.x = x;
                    this.y = y;
                }
            },

            stopDrawing(event) {
                if (this.isDrawing) {
                    const { x, y } = this.getCanvasCoordinates(event);
                    this.drawLine(this.x, this.y, x, y);
                    this.isDrawing = false;
                    this.captureImage()
                }
            },

            captureImage() {
                const canvas = this.$refs.drawingcanvas;
                this.drawedImage = canvas.toDataURL("image/png");

                canvas.toBlob((blob) => {

                    this.file = new File([blob], "drawn-image.png", { type: "image/png" });

                    // File input.
                    const dataTransfer = new DataTransfer();
                    dataTransfer.items.add(this.file);

                    this.$emit('drawn')
                    this.$emit('change', this.file);

                }, "image/png", 0.95);
            },

            reset(notify = false) {
                const canvas = this.$refs.drawingcanvas;
                const ctx = canvas.getContext('2d')
                ctx.clearRect(0, 0, canvas.width, canvas.height)

                this.drawedImage = null;
                this.file = null
    
                if (notify) {
                    this.$emit('erased')
                }
            },

            restore(src) {
                const canvas = this.$refs.drawingcanvas;
                const img = new Image()

                this.ctx = canvas.getContext('2d')
                this.adjustCanvasSize()

                img.onload = () => {
                    this.ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
                }
                img.onerror = (err) => {
                    console.error('Error loading image:', err)
                }
                img.src = src
            },

            post() {

                let formData = new FormData();
                formData.append("_token", this.$auth['csrf-token']);
                for (let prop in this.formData) {
                    // Workaround to not send null values as strings!
                    if (this.formData[prop] !== null) {
                        formData.append(prop, this.formData[prop]);
                    }
                }
                if (this.file) {
                    formData.append('file', this.file);
                }

                axios.post(this.url, formData)
                    .then(resp => {
                        this.$emit('complete', null)
                        this.$emit('success', null)
                    })
                    .catch(error => {
                        if (error.response.status == 422) {
                            this.$emit('complete', null)
                            this.$emit('errors', error.response.data.errors)
                        } else {
                            //this.$auth.handleErrorVm(error, this)
                        }
                    })
            },
        },
    }
</script>

<style scoped>

    .drawing-canvas {
        width: 100%;
        height:auto;
        border: 1px solid #dee2e6;
        touch-action: none;      /* critical on mobile */
        -ms-touch-action: none;  /* old Edge */
    }
    .tools {
        text-align: right;
    }

</style>
